'use client';

import React from 'react';
import MyPickSwiper from 'src/components/main/Section/MyPickSection/MyPickSwiper/MyPickSwiper';

import MyPickSectionStyled from './MyPickSection.style';

const MyPickSection = () => {
  return (
    <MyPickSectionStyled.Container>
      <MyPickSectionStyled.TitleWrapper>
        {/* 타이틀 */}
        <MyPickSectionStyled.Title>My Pick</MyPickSectionStyled.Title>

        {/* 설명 */}
        <MyPickSectionStyled.Description>선호하는 브랜드를 모아보세요</MyPickSectionStyled.Description>
      </MyPickSectionStyled.TitleWrapper>

      {/* 스와이퍼 */}
      <MyPickSwiper />
    </MyPickSectionStyled.Container>
  );
};

export default MyPickSection;
